<template>
  <footer class="footer">
    <div class="container-fluid d-flex flex-wrap justify-content-between">
      <nav>
        <ul class="footer-menu">
          <li>
            <router-link :to="{path:'/admin'}">Dashboard</router-link>
          </li>
        </ul>
      </nav>
      <div class="copyright">
        &copy; 
        <a href="https://huestimates.com/" target="_blank" rel="noopener">HU Estimates LLC</a>.
        Progress IMS Claims Manager
      </div>
    </div>
  </footer>
</template>
<script>
  export default {
  }

</script>
<style>

</style>
